export default {
    color: {
        primary: '#29ABE2', 
        white: '#fff',
        darkgrey: '#717171',
        lightgrey: '#EFEFEF',
        lightergrey: '#F4F4F4',
    }
}